import { useTranslation } from "react-i18next";

const ClientHeader = ({ onSort, sortByField, orderSortByField }) => {
  const { t } = useTranslation();

  const handleSort = (field) => {
    if (!onSort) return;
    if (sortByField === field) {
      onSort(field, orderSortByField === "1" ? "-1" : "1");
    } else {
      onSort(field, "1");
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    return "fa-sort";
  };

  return (
    <article className="table-standard-header">
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("name")}
      >
        {t("settingsClients.columnOrigin")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("name")}`} />
        </span>
      </div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("clientUniqueId")}
      >
        {t("settingsClients.columnReference")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("clientUniqueId")}`} />
        </span>
      </div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("createdAt")}
      >
        {t("settingsClients.columnCreatedAt")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("createdAt")}`} />
        </span>
      </div>
    </article>
  );
};

export default ClientHeader;
